import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-toast',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-toast works!</p> `,
  styles: ``,
})
export class CpToastComponent {}
